import { useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';
import { useContext } from "react";
import { UIContext } from "@/contexts/UIContext";
let socket;

export default function useChat() {



      const { thisUser } = useContext(UIContext);


  const [messages, setMessages] = useState([]);
  const [connected, setConnected] = useState(false);
  const messagesRef = useRef([]);

  useEffect(() => {
    if (!thisUser?.user_uuid) return; // wait until user is known

    // connect to Socket.IO server
    socket = io('http://localhost:4000');
    if (!socket) { return; }

    socket.on('connect', () => {
      console.log('connected to Socket.IO server', socket.id);
      setConnected(true);

      // 🔑 AUTH STEP
      socket.emit('auth', {
        userUuid: thisUser.user_uuid,
        filteredUserData: {
          user_full_name: `${thisUser.user_first_name} ${thisUser.user_last_name}`,
          user_handle: thisUser.user_handle,
          user_avatar: thisUser.user_avatar,
          user_uuid: thisUser.user_uuid,
        }
        // userFirstName: thisUser.user_first_name, 
        // userLastName: thisUser.user_last_name,
        // userAvatar: thisUser.user_avatar,
        // userHandle: thisUser.user_handle
      });
    });

    socket.on('chat:message', ({chatUUID, msg, senderUserData, createdDate}) => {
      messagesRef.current = [...messagesRef.current, {chatUUID, text:msg, senderUserData: senderUserData, createdDate: createdDate}];
      setMessages([...messagesRef.current]);
    });

    socket.on('disconnect', () => {
      console.log('disconnected from server');
      setConnected(false);
    });

    return () => {
      socket.disconnect();
    };
  }, [thisUser?.user_uuid]);

  const sendMessage = ({chatUUID, msg}) => {
    if (!socket) return;
    // socket.emit('message', msg);
      socket.emit('chat:message', {
        chatUUID,
        msg
      });
  };

  const joinChat = (chatUUID) => {
    if (!socket) return;
    socket.emit('chat:join', { chatUUID });
  };

  return { messages, sendMessage, connected, setConnected, joinChat };
}
